import React from "react";
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";
import shrj from "../assets/images/medical_logo/shrj.jpg";
import shxh from "../assets/images/medical_logo/shxhyy.jpg";
import shfdek from "../assets/images/medical_logo/fddxyy.jpg";
import tjyk from "../assets/images/medical_logo/tjykdxzyy.jpg";
import tjzl from "../assets/images/medical_logo/tjszlyy.jpg";
import njet from "../assets/images/medical_logo/njetyy.jpg";
import szdxfy from "../assets/images/medical_logo/sdfyy.jpg";
import szsl from "../assets/images/medical_logo/szslyy.jpg";
import szkjc from "../assets/images/medical_logo/szkjcyy.jpg";
import zjdxfy from "../assets/images/medical_logo/zdyy.jpg";

import bbyxydyfsyy from '../assets/images/medical_logo/bbyxydyfsyy.jpg';
import ahsetyy from '../assets/images/medical_logo/ahsetyy.jpg';
import bzyxyfsyy from '../assets/images/medical_logo/bzyxyfsyy.jpg';
import cdsdqrmyy from '../assets/images/medical_logo/cdsdqrmyy.jpg';
import hbkgzyy from '../assets/images/medical_logo/hbkgzyy.jpg';
import hzszyy from '../assets/images/medical_logo/hzszyy.jpg';
import jmsdermyy from '../assets/images/medical_logo/jmsdermyy.jpg';
import scsdsrmyy from '../assets/images/medical_logo/scsdsrmyy.jpg';
import whzxyy from '../assets/images/medical_logo/whzxyy.jpg';
import zdyy from '../assets/images/medical_logo/zdyy.jpg';


const CourseCatOne = () => {
  const params = {
    slidesPerView: 6,
    loop: true,
    speed: 1000,
    spaceBetween: 30,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },

    // Responsive breakpoints
    breakpoints: {
      1024: {
        slidesPerView: 6
      },
      768: {
        slidesPerView: 4
      },
      640: {
        slidesPerView: 3
      },
      320: {
        slidesPerView: 2
      }
    }
  };

  return (
    <section className="thm-gray-bg course-category-one">
      <div className="container-fluid text-center">
        <div className="block-title text-center">
          <h2 className="block-title__title">
            都有什么医院 <br />
            在使用
          </h2>
        </div>
        <div className="course-category-one__carousel">
          <Swiper {...params}>
            <div className="item">
              <div className="course-category-one__single color-1">
                <div className="">                 
                   <img src={shrj}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">上海交通大学附属瑞金医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-2">
                <div className="">
                  <img src={shxh}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">上海新华医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-3">
                <div>
                <img src={shfdek}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">复旦大学附属儿科医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-4">
                <div >
                <img src={zjdxfy}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">浙江大学附属第一医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-5">
                <div>
                <img src={tjyk}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">天津医科大学总医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-6">
                <div>
                <img src={tjzl}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">天津肿瘤医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-1">
                <div>
                <img src={njet}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">南京市儿童医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-2">
                <div >
                <img src={szdxfy}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">苏州大学附属第一医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-3">
                <div>
                <img src={szkjc}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">苏州科技城医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-4">
                <div>
                <img src={szsl}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">苏州市立医院</a>
                </h3>
              </div>
            </div>
          </Swiper>
        </div>
        <div className="course-category-one__carousel">
          <Swiper {...params}>
            <div className="item">
              <div className="course-category-one__single color-1">
                <div className="">                 
                   <img src={bbyxydyfsyy}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">蚌埠医学院第一附属医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-2">
                <div className="">
                  <img src={ahsetyy}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">安徽省儿童医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-3">
                <div>
                <img src={bzyxyfsyy}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">滨州医学院附属医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-4">
                <div >
                <img src={cdsdqrmyy}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">成都市第七人民医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-5">
                <div>
                <img src={hbkgzyy}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">淮北矿工总医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-6">
                <div>
                <img src={hzszyy}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">杭州市中医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-1">
                <div>
                <img src={jmsdermyy}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">荆门市第二人民医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-2">
                <div >
                <img src={whzxyy}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">武汉中心医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-3">
                <div>
                <img src={scsdsrmyy}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">四川省人民医院</a>
                </h3>
              </div>
            </div>
            <div className="item">
              <div className="course-category-one__single color-4">
                <div>
                <img src={zdyy}  className="course-category-one__icon" alt="" />
                </div>
                <h3 className="course-category-one__title">
                  <a href="#none">浙大一院</a>
                </h3>
              </div>
            </div>
          </Swiper>
        </div>
       {/* <a href="#none" className="thm-btn">
          显示全部
        </a> */}
      </div>
    </section>
  );
};
export default CourseCatOne;
